import { Link, Navigate, useParams } from 'react-router-dom';
import { getBlogPost } from '../content/blog';

export function BlogPostPage() {
  const { slug } = useParams();
  const post = slug ? getBlogPost(slug) : undefined;
  if (!post) return <Navigate to="/blog" replace />;

  return (
    <article className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[720px]">
        <Link to="/blog" className="mb-6 inline-block text-[0.82rem] font-semibold text-ink-3 hover:text-brand">
          ← Journal
        </Link>
        <p className="mb-3 text-[0.72rem] font-bold tracking-widest text-brand uppercase">{post.date}</p>
        <h1 className="font-display mb-6 text-[2.25rem] leading-[1.1] font-extrabold text-ink lg:text-[2.75rem]">
          {post.title}
        </h1>
        <div className="space-y-4 text-[1.02rem] leading-[1.75] text-ink-2">
          {post.paragraphs.map((p) => (
            <p key={p.slice(0, 40)}>{p}</p>
          ))}
        </div>
        <p className="mt-10 text-[0.88rem] text-ink-3">
          Related: <Link to="/help" className="font-semibold text-brand">Help centre</Link>
        </p>
      </div>
    </article>
  );
}
